import React, { Fragment, useEffect, useMemo, useState } from "react";
import Section from "../Section";
// import useMeasure from "react-use/lib/useMeasure";
import log from "cslog";
import { useAtom } from "jotai";
// import { useRouter } from "next/router";
import { useRouter } from "../../../../juntion";
import useWindowSize from "react-use/lib/useWindowSize";
import { PAGE_AFTER_ID } from "../../../../../data/defaults";
// import { useContent } from "../../../../dynamicdata/query";
import { useContent } from "../../../../junctionAbs";
import { globalVarsAtom, usePageDbConfig } from "../../../../db";
import { PAGE_BEFORE_ID, sectionListAtom } from "../../../../juntion";
import ActionUI from "../special/ActionUI";
import QLightbox from "../special/QLightbox";
// import dynamic from "next/dynamic";
import SectionDynamic from "./SectionDynamic";
import { nanoid } from "nanoid";
import { cloneDeep } from "lodash";
import produce from "immer";
import { useItemsFine } from "../../../../juntion";

// const TrackPageView = dynamic(
// 	() => import("../../../../../analytics/TrackPageView"),
// 	{ ssr: false }
// );


const PAGE_SEPERATOR_HEIGHT = 10;

function PageDynamicNew({
	id,
	db,
	gs,
	dydb,
	info,
	root_info,
	layout,
	page_info,
	pageBeforeData,
	pageAfterData,
	ctx,
	query,
	load_fonts = false
}) {
	const router = useRouter();
	const { width, height } = useWindowSize(1024, undefined);

	const [runtime_data, setRuntimeData] = useState({});
	const [runtime_db, setRuntimeDb] = useState({});
	const [runtime_content, setRuntimeContent] = useState({});

	const [placeholders, setPlaceholders] = useState(new Set());


	// const data = db[id];
	const data = {
		...db[id],
		...runtime_data
	}
	const gv = useAtom(globalVarsAtom);

	const device = width;
	// const device = 1200;

	// log.d(info, "Page Infoo");

	// useEffect(() => {
	//     log.p("Now scrolling to top");
	//     window.scrollTo(0, 0);
	// }, []);

	// log.d(ctx, "CTX in page");


	// ===========================================
	// const page_before_data = pageBeforeData.html[PAGE_BEFORE_ID];

	// let page_after_data = null;
	// if (pageAfterData) {
	// 	page_after_data = pageAfterData.html[PAGE_AFTER_ID];
	// }

	const paths = useMemo(() => {
		// log.p("Recalculating paths");
		const out = {};
		if (info.paths?.length > 0) {
			info.paths.forEach((path, index) => {
				out[path] = query[index + 2];
			});
		}
		return out;
	}, [query, info.paths]);

	const [dbc, setDBC] = usePageDbConfig(id);
	// log.d(dydb, "Unparsed db in page");
	const content = useContent(dydb, dbc, paths, ctx?.organization);
	const all_content = {
		gv: {
			status: "success",
			isSuccess: true,
			// data: globalVariables,
			data: gv,
		},
		...content,
	};


	const is_document = root_info.type === "document";


	const layout_default = layout?.["default"];
	const page_dims = layout_default?.pageSize?.value || {}; // for document
	const page_margin = layout_default?.pageMargins?.params || { left: 0, right: 0, top: 0, bottom: 0 };
	const page_dims_inner = {
		width: page_dims.width - page_margin.left - page_margin.right,
		height: page_dims.height - page_margin.top - page_margin.bottom,
		margin: page_margin,
	}; // for document

	// log.d(is_document, "is_document in Page")
	// log.d(root_info, "root_info in Page")
	// log.d(layout, "Layout in Page")
	// log.d(page_dims_inner, "page_dims_inner in Page")

	const [ready_sections, setReadySections] = useState([])



	const createIt = async (id, pid, data, db) => {
		data = cloneDeep(data);
		data = { ...data, id: id, pid: pid };
		if ("child" in data) {
			const cid = nanoid(10);
			const cdata = db[data.child];
			createIt(cid, id, cdata, db);
			data = { ...data, child: cid };
		} else if ("childs" in data) {
			data.childs.map(async (child, index) => {
				const childId = nanoid(10);
				data.childs[index] = childId;
				let childData = db[child];
				childData = { ...childData, id: childId };
				createIt(childId, id, childData, db);
			});
		}
		// addElement(id, data);
		db[id] = data;
	};


	const applyTemplate = (template, new_db, index, section_id) => {
		let html = template.data;
		log.d(template, "applying_temp Template Data");

		// let rootid = nanoid(10);
		let rootid = section_id;
		let rootdata = html["root"];
		// log.d(rootdata, "applying_temp rootdata");

		const new_section_data = {
			...rootdata,
			input: {
				...rootdata.input,
				name: rootid,
			},
			used_template: {
				id: template.id,
				created_by: template.user_created,
			},
		};


		createIt(rootid, data.pid, new_section_data, html);

		// setRuntimeDb(html)
		setRuntimeDb(old_db => {
			return {
				...old_db,
				...html
			}
		})



		setRuntimeData(old_data => {
			return {
				...old_data,
				// [section_id]: {
				[section_id]: {
					rendered: true,
					id: rootid,
				}
			}
		})
		setRuntimeContent(old_db => ({ ...old_db, [rootid]: new_db }))

		setReadySections(old_sections => [...old_sections, {
			id: rootid,
			rendered: true,
			// prefill: new_prefill
		}])
	}

	// -----------------------------------------------------------------------------
	const [all_templates, setAllTemplates] = useState([]);
	const { isSuccess: successAllTemplates, isLoading: loadingAllTemplates, data: dataAllTemplates } = useItemsFine("qp_block_template",
		// `filter[used_schemas][qdb_creation_schema_id][block_id][_in]=[${all_templates.join(",")}]&fields=*,used_schemas.qdb_creation_schema_id.*`,
		`filter=${JSON.stringify({
			"used_schemas": {
				"qdb_creation_schema_id": {
					"block_id": {
						"_in": all_templates
					}
				}
			}
		})}&fields=*,used_schemas.qdb_creation_schema_id.*`,
		all_templates?.length > 0
	)
	// -----------------------------------------------------------------------------


	useEffect(() => {
		if (successAllTemplates) {
			const templates_objs = {};
			log.d(dataAllTemplates, "Data All Templates")
			dataAllTemplates?.forEach((template) => {
				templates_objs[template?.used_schemas?.[0]?.qdb_creation_schema_id?.block_id] = template
			})
			log.d(templates_objs, "Templates Objects")
			data?.section_list?.forEach((section, index) => {
				const template = templates_objs[section?.preset]
				if (template) {
					const new_db = {
						status: "success",
						isLoading: false,
						isSuccess: true,
						data: section?.prefill
					}
					applyTemplate(template, new_db, index, section?.id)
				}
			})
		}
	}, [successAllTemplates, dataAllTemplates])



	useEffect(() => {
		if (all_templates?.length === 0) {
			const out = []
			data?.section_list?.forEach((section) => {
				if (!out.includes(section.preset)) {
					out.push(section?.preset)
				}
			})
			setAllTemplates(out)
		}
	}, [data])


	const final_db = {
		...db,
		...runtime_db
	}


	// const final_content = {
	// 	...all_content,
	// 	...runtime_content
	// }

	log.d(final_db, "final_db in PDN")



	// log.d(final_data, "applying final_data");

	return (
		<PageWrapper is_document={is_document} background={layout_default?.background?.value} page_dims={page_dims}>
			{/* <TrackPageView /> */}
			{/* <h3>Dynamic Page</h3>
			<pre>{JSON.stringify(data.section_list, null, 2)}</pre>
			<h3>runtime content</h3>
			<pre>{JSON.stringify(runtime_content, null, 2)}</pre> */}



			<p>Qureal Dynamic Page Render</p>
			{/* <p>id: {id}</p> */}
			{/* <p>data</p> */}
			{/* <pre>{JSON.stringify(data, null, 2)}</pre> */}

			<p>ready_sections</p>
			<pre>{JSON.stringify(ready_sections, null, 2)}</pre>
			{/* <p>all templates</p> */}
			{/* <pre>{JSON.stringify(all_templates, null, 2)}</pre> */}
			{/* <p>data all templates</p> */}
			{/* {successAllTemplates && <pre>{JSON.stringify(dataAllTemplates, null, 2)}</pre>} */}


			{ready_sections?.map((section_item, index) => {
				const final_section_item = {
					...section_item,
					...(section_item.id in runtime_data ? runtime_data[section_item.id] : {})
				}
				if (final_section_item.type === "dynamic" && !final_section_item.rendered) {
					return <pre key={index}>{JSON.stringify(section_item, null, 2)}</pre>

				} else {
					const item = section_item.id;
					// const item = final_section_item?.id;

					if (!final_db[item]) {
						return <div style={{ border: "1px dotted red" }}>
							<p>Error Rendeing seciton:
								<pre>{JSON.stringify(final_section_item, null, 2)}</pre>
							</p>
						</div>
					}

					// return <div>
					// 	<p>Next section {item}</p>
					// 	<pre>{JSON.stringify(final_section_item, null, 2)}</pre>
					// </div>

					return (
						<Fragment key={index}>

							<Section
								key={item}
								id={item}
								index={index}
								db={final_db}
								// dydb={dydb}
								// dydb={all_content}
								dydb={{
									...all_content,
									...(item in runtime_content ? runtime_content[item] : {}),
								}}
								gs={gs}
								device={device}
								ctx={ctx}
								page_dims_inner={page_dims_inner}
								is_document={is_document}
								addSection={() => {
									// const phs = Array.from(placeholders);
									// phs.push(index);
									const newPh = new Set(placeholders);
									newPh.add(index);
									setPlaceholders(newPh);
								}}
							/>
						</Fragment>
					);
				}
			})}


			{/* {section_list.map((section_item, index) => {
				// log.d(section_item, "applying Next Section_item");
				const final_section_item = {
					...section_item,
					...(section_item.id in runtime_data ? runtime_data[section_item.id] : {})
				}
				// if (final_section_item.type === "dynamic" && !final_section_item.rendered) {
				if (final_section_item.type === "dynamic" && !final_section_item.rendered) {
					return <pre key={index}>{JSON.stringify(section_item, null, 2)}</pre>
			
				} else {
					const item = section_item.id;
					// const item = final_section_item?.id;

					if (!final_db[item]) {
						return <div style={{ border: "1px dotted red" }}>
							<p>Error Rendeing seciton:
								<pre>{JSON.stringify(final_section_item, null, 2)}</pre>
							</p>
						</div>
					}

					return (
						<Fragment key={index}>

							<Section
								key={item}
								id={item}
								index={index}
								db={final_db}
								// dydb={dydb}
								// dydb={all_content}
								dydb={{
									...all_content,
									...(item in runtime_content ? runtime_content[item] : {}),
								}}
								gs={gs}
								device={device}
								ctx={ctx}
								page_dims_inner={page_dims_inner}
								is_document={is_document}
								addSection={() => {
									// const phs = Array.from(placeholders);
									// phs.push(index);
									const newPh = new Set(placeholders);
									newPh.add(index);
									setPlaceholders(newPh);
								}}
							/>
						</Fragment>
					);
				}
			})} */}



			{/* {data.sections.map((item, index) => {
				return (
					<Section
						key={item}
						id={item}
						index={index}
						db={db}
						// dydb={dydb}
						dydb={all_content}
						gs={gs}
						device={device}
						ctx={ctx}
						page_dims_inner={page_dims_inner}
						is_document={is_document}
					/>
				);
			})} */}


			<ActionUI db={pageBeforeData.html} gs={gs} device={device} />
			<QLightbox />

			{load_fonts && [gs.config?.primaryFont, gs.config?.secondryFont].map((font) => {
				return (
					<link
						key={font}
						href={`https://fonts.googleapis.com/css2?family=${font}&display=swap`}
						rel="stylesheet"
						crossOrigin="anonymous"
					/>
				);
			})}
		</PageWrapper>
	);
}

export default PageDynamicNew;


function PageWrapper({ is_document, background, children, page_dims }) {
	if (is_document) {
		return <div style={{
			backgroundColor: background,
			height: "auto",
			minHeight: page_dims?.height ? page_dims.height + PAGE_SEPERATOR_HEIGHT : "100%",
		}}>{children}</div>
	} else {
		return children
	}
}